class SuccessModal {
	constructor(modal) {
		this.modal = modal;
		this.dialog = modal.querySelector('.success-modal__dialog');
		this.sectionId = modal.dataset.sectionId || '';
		this.formId = modal.dataset.formId || '';
		this.isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
		this.lastTrigger = null;

		this.boundHandleClick = this.handleClick.bind(this);
		this.boundHandleKeydown = this.handleKeydown.bind(this);

		document.addEventListener('click', this.boundHandleClick);
		document.addEventListener('keydown', this.boundHandleKeydown);

		if (this.isDesignMode) {
			this.bindEditorPreviewEvents();
		}

		this.bindFormSubmitTagging();
		this.checkAutoOpen();
	}

	// Shopify's contact-form redirect target isn't guaranteed to preserve the
	// original URL's fragment or query string, so neither is reliable for
	// detecting "this form was just submitted" after the round trip.
	// sessionStorage survives the navigation regardless of the final URL.
	bindFormSubmitTagging() {
		if (!this.formId) return;
		// Multiple contact forms on a page (e.g. the Contact page's own form and
		// a footer contact form block) each need a unique id to stay valid HTML,
		// so match any form id that starts with this modal's configured formId
		// rather than requiring an exact match.
		const forms = document.querySelectorAll(`form[id^="${this.formId}"]`);
		if (!forms.length) return;

		forms.forEach((form) => {
			form.addEventListener('submit', (event) => {
				if (event.defaultPrevented) return;

				try {
					window.sessionStorage.setItem('shopify-form-submitted', this.formId);
				} catch (error) {
					// sessionStorage unavailable (e.g. private browsing) — auto-open just won't fire.
				}
			});
		});
	}

	checkAutoOpen() {
		let submittedFormId = null;
		try {
			submittedFormId = window.sessionStorage.getItem('shopify-form-submitted');
		} catch (error) {
			submittedFormId = null;
		}

		if (!submittedFormId || !this.formId || submittedFormId !== this.formId) return;

		const marker = document.querySelector('meta[name="shopify-contact-status"]');
		const status = marker ? marker.getAttribute('content') : null;

		if (status === 'success') {
			this.showSuccess();
		} else if (status === 'error') {
			this.showError();
		}

		try {
			window.sessionStorage.removeItem('shopify-form-submitted');
		} catch (error) {
			// no-op
		}
	}

	bindEditorPreviewEvents() {
		document.addEventListener('shopify:section:select', (event) => {
			if (event.detail && event.detail.sectionId === this.sectionId) {
				this.showSuccess();
			}
		});

		document.addEventListener('shopify:section:deselect', (event) => {
			if (event.detail && event.detail.sectionId === this.sectionId) {
				this.close();
			}
		});
	}

	handleClick(event) {
		if (!this.isOpen()) return;
		if (event.target.closest(`[data-success-modal-close]`) && this.modal.contains(event.target.closest(`[data-success-modal-close]`))) {
			event.preventDefault();
			this.close();
		}
	}

	handleKeydown(event) {
		if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.isOpen()) {
			this.close();
		}
	}

	isOpen() {
		return !this.modal.hasAttribute('hidden');
	}

	showSuccess() {
		this.modal.classList.remove('success-modal--error');
		this.modal.classList.add('success-modal--success');
		this.open();
	}

	showError() {
		this.modal.classList.remove('success-modal--success');
		this.modal.classList.add('success-modal--error');
		this.open();
	}

	open() {
		if (this.isOpen()) return;

		this.modal.removeAttribute('hidden');
		document.body.classList.add('overflow-hidden');

		const firstFocusable = this.modal.querySelector('button, a[href]');
		if (typeof trapFocus === 'function') {
			trapFocus(this.dialog, firstFocusable || this.dialog);
		} else if (firstFocusable) {
			firstFocusable.focus();
		}
	}

	close() {
		this.modal.setAttribute('hidden', 'hidden');
		document.body.classList.remove('overflow-hidden');

		if (typeof removeTrapFocus === 'function') {
			removeTrapFocus(this.lastTrigger || null);
		}
	}
}

if (!window.successModals) {
	window.successModals = {};
	document.querySelectorAll('[data-success-modal]').forEach((modal) => {
		window.successModals[modal.dataset.successModal] = new SuccessModal(modal);
	});
}
